import Vue from 'vue';
import PrimeVue from 'primevue/config';

Vue.use(PrimeVue, {ripple: true});